import styles from "./PaymentSuccess.module.scss";
import successicon from "../../assets/images/payment-status/success.svg";
import MainButton from "../../components/shared/button/MainButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const { data } = useSelector((state: RootState) => state.translationData);

  const handleRedirect = () => {
    switch (type) {
      case "courier":
        navigate("/account/courier");
        break;
      case "azerpost":
        navigate("/account/mail");
        break;
      case "ypOrder":
        navigate("/account/ypOrder");
        break;
      case "balance":
        navigate("/account/my-balance");
        break;
      case "bulk":
        navigate("/account/my-packages");
        break;
      case "wolt":
        navigate("/account/wolt");
        break;
      case "card_registration":
        navigate("/account/bank-cards");
        break;
      default:
        navigate("/account/my-foriegn-locations");
    }
  };

  return (
    <div className={styles.background}>
      <div className={styles.modal}>
        <div className={styles.icon}>
          <img src={successicon} alt="success" />
        </div>
        <h1 className={styles.title}>{data?.payment_success}</h1>
        <p className={styles.subtitle}>{data?.auth_common_thank_you}</p>
        <div className={styles.back_btn}>
          <MainButton onClick={handleRedirect} text="Geri dön" />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
